import { ConfigProvider } from 'antd';
import antAR from 'antd/locale/ar_EG';
import antEN from 'antd/locale/en_US';
import 'bootstrap/dist/css/bootstrap.min.css';
import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import i18n from 'i18next';
import { useEffect } from 'react';
import { useRoutes } from 'react-router-dom';
import OfflineIndicator from './components/OfflineIndicator';
import { useInternetConnection, useOfflineMutations } from './hooks/useConnection';
import routes from './routes';
import { initDeviceId } from './utils/getDeviceId';

dayjs.extend(utc);
dayjs.extend(timezone);

function App() {
  const element = useRoutes(routes);
  const isArabic = i18n.language === 'ar';

  useEffect(() => {
    initDeviceId();
  }, []);

  // Handle connection and offline mutations
  const isOnline = useInternetConnection();
  useOfflineMutations();

  // Handle pin checking
  // const { pin, allow, setAllow } = usePinChecker();

  return (
    <ConfigProvider locale={isArabic ? antAR : antEN} direction={isArabic ? 'rtl' : 'ltr'}>
      <OfflineIndicator isOnline={isOnline} />
      {element}
      {/* {!allow && <PinChecker pin={pin} onPass={() => setAllow(true)} />} */}
    </ConfigProvider>
  );
}

export default App;
